import * as React from "react"

import { cn } from "@/lib/utils"
import { NumericKeypad } from "../common/NumberKeypadCore"

const BASE_CLASS = "flex h-12 w-full rounded-md border border-input bg-transparent px-4 py-2 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50";

// Altezza 48px e padding generoso per uso touch (TPV/tablet).
// I campi numerici (type="number") aprono automaticamente un tastierino a
// comparsa, grande e adatto al touch, su qualsiasi pagina dell'app.
const Input = React.forwardRef(({ className, type, onChange, value, disabled, step, min, max, inputMode, ...props }, ref) => {
  const [open, setOpen] = React.useState(false);

  if (type === "number") {
    const fire = (v) => { if (onChange) onChange({ target: { value: v } }); };
    const openKeypad = () => { if (!disabled) setOpen(true); };
    return (
      <>
        <input
          type="text"
          inputMode="decimal"
          readOnly
          value={value ?? ""}
          disabled={disabled}
          onClick={openKeypad}
          onFocus={(e) => { e.target.blur(); openKeypad(); }}
          className={cn(BASE_CLASS, "cursor-pointer", className)}
          ref={ref}
          {...props}
        />
        <NumericKeypad
          open={open}
          onClose={() => setOpen(false)}
          initial={value}
          decimal
          title="Inserisci valore"
          suffix=""
          onConfirm={fire}
        />
      </>
    );
  }

  return (
    <input
      type={type}
      value={value}
      onChange={onChange}
      disabled={disabled}
      inputMode={inputMode}
      className={cn(BASE_CLASS, className)}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
